export default defineNuxtRouteMiddleware(() => {
  const state = useState("current-locale");

  // Se já tiver sido definido antes, não faz nada!
  if (state.value) return;

  // Suportar locales: pt, en, es
  const supportedLocales = ["pt", "en", "es"];

  // 1. Primeira prioridade: cookie (user preference)
  const cookie = useCookie("i18n_locale");
  if (cookie.value && supportedLocales.includes(cookie.value)) {
    state.value = cookie.value;
    return;
  }

  // 2. Segunda prioridade: detectar locale do navegador
  if (process.client) {
    const browserLocale = navigator.language?.split("-")[0] || "";
    if (supportedLocales.includes(browserLocale)) {
      state.value = browserLocale;
      return;
    }
  }

  // 3. Fallback: português (PT)
  state.value = "pt";
});
